var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrderWidget',{attrs:{"code":_vm.code}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }